/**
 * ShellSwitcher — force Stepper for every project workspace page.
 *
 * The classic FlexLayout desktop shell was retired in Iter I-25 to
 * match the "left panel only" simplification. Non-project pages
 * (dashboard, admin, settings, projects list) render via `<Outlet />`
 * so the parent route's child <Route> elements resolve normally.
 */
import { Outlet, useLocation } from "react-router-dom";
import StepperShell from "@/components/stepper/StepperShell";
import UnifiedTopNav from "@/components/UnifiedTopNav";

export default function ShellSwitcher() {
  const loc = useLocation();
  // Project workspace URLs get the full stepper (its own top bar +
  // left rail + main pane).
  // Exception: URLs with a `/w/:slug` segment are dedicated workspace
  // deep-links (Iter 77) and must always render ProjectDetailPage
  // — never the stepper — so tabs like Pit Design remain reachable.
  const isProjectWorkspace = /^\/projects\/[^/]+\/?$/.test(loc.pathname);
  if (isProjectWorkspace) return <StepperShell />;

  // Every other authenticated route (Dashboard, Projects list, Admin,
  // Settings, Billing, Profile, etc.) gets the shared top-nav ribbon
  // and defers to React Router's child <Outlet /> for the page body.
  return (
    <div className="min-h-screen bg-background text-foreground">
      <UnifiedTopNav />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
